<template>
  <div id="app">
    <v-app>
      <nav-bar :isCheckout="isCheckout"></nav-bar>
      <v-content>
        <router-view></router-view>
      </v-content>
      <app-footer :isCheckout="isCheckout" />
      <snackbar />
    </v-app>
  </div>
</template>

<script>
  import NavBar from './components/System/NavBar.vue'
  import Footer from './components/Footer/Footer'
  import Snackbar from "./components/System/Snackbar";

  export default {
    name: 'app',
    metaInfo: {
      title: 'Fruitisimo Bistro Cafe',
      titleTemplate: '%s | Fruitisimo Bistro Cafe'
    },
    components: {
      NavBar,
      'AppFooter': Footer,
      Snackbar
    },
    data () {
      return {
        isCheckout: false
      }
    },
    mounted() {
      this.isCheckout = this.$router.currentRoute.name === 'Checkout';
    },
    watch: {
      '$route.name': function (val) {
        this.isCheckout = val === 'Checkout';
      }
    },
  }
</script>

<style lang="scss">
  .v-application {
    font-family: 'Josefin Sans', sans-serif !important;
    .body-2 {
      font-family: 'Josefin Sans', sans-serif !important;
    }
  }
</style>
